<script>
  import { createEventDispatcher } from 'svelte';
  import { fade, fly } from 'svelte/transition';

  import jQuery from 'jquery';

  import BrowserUtils from '@utils/browser-utils';
  import { getGlobalStore } from '@stores/global';
  import { browser } from '$app/environment';
  let globalStateStore = getGlobalStore('globalStateStore');

  const dispatch = createEventDispatcher();
  const SLOTS = $$props.$$slots;

  export let header = null;
  export let show = false;
  export let showCloseButton = true;
  export let mobile = false;
  export let allowClose = true;
  export let modalLocation = 'top';
  export let closeOnOverlayClick = true;
  export let fadeInDuration = 200;
  export let closeButtonSize = 'normal'; // | 'large'
  export let slideIn = null;
  export let bodyScrollable = false;

  let slideInDuration = slideIn ? 400 : 0;
  let slideInX = 0;

  if (slideIn == 'left') {
    slideInX = -450;
  } else if (slideIn == 'right') {
    slideInX = 450;
  }

  let parentNode;
  let clickedInside = false;

  export let hide = function () {
    if (allowClose) {
      show = false;
      dispatch('close');
    }
  };

  let handleKeydown = function (event) {
    if (event.key == 'Escape') {
      hide();
    }
  };

  var setupModal = function (node) {
    globalStateStore.set({ modalOpen: true });
    parentNode = jQuery(node).parent();

    if (parentNode.length > 0 && !parentNode.is('#rendered-modals')) {
      let parentSvelteClass = parentNode.closest('[class*=svelte]').attr('class');

      jQuery('body').width(jQuery('body').width());
      jQuery(node).addClass(parentSvelteClass).appendTo('#rendered-modals');
      if (!bodyScrollable) {
        jQuery('body').css('overflow', 'hidden');
      }
      dispatch('show');
    }

    return {
      destroy() {
        try {
          if (node && jQuery(node).is(':visible')) {
            jQuery(node).appendTo(parentNode);
          }

          if (jQuery('#rendered-modals').children('.b-modal').length == 0) {
            jQuery('body').removeAttr('style');
          }
        } catch {}

        dispatch('unmounted');
      },
    };
  };
</script>

<style style="text/scss" lang="scss">
  @import '../vendor/design-system.scss';

  .b-modal {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modal__overlay {
    background: rgba(22, 13, 54, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }

  .modal__container {
    background-color: #fff;
    padding: 30px;
    max-width: 600px;
    border-radius: 16px;
    overflow: auto;
    box-sizing: border-box;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    overflow-x: hidden;
  }

  .modal__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .modal__title {
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: black;
    box-sizing: border-box;
  }

  .modal__close {
    color: $neutral-gray;
    background: transparent;
    border: 0;
    cursor: pointer;
    z-index: 2;

    &:hover {
      font-weight: bold;
    }
  }

  .modal__header .modal__close:before {
    content: '\2715';
  }

  .modal__close_ios:before {
    font-size: 22px;
  }

  .modal__close::before {
    font-size: 16px;
  }

  .with-large-close-button {
    .modal__close::before {
      font-size: 22px;
    }
  }

  .modal__content {
    margin-top: 2rem;
    margin-bottom: 2rem;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.8);
  }

  .modal__btn {
    font-size: 0.875rem;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    background-color: #e6e6e6;
    color: rgba(0, 0, 0, 0.8);
    border-radius: 0.25rem;
    border-style: none;
    border-width: 0;
    cursor: pointer;
    -webkit-appearance: button;
    text-transform: none;
    overflow: visible;
    line-height: 1.15;
    margin: 0;
    will-change: transform;
    -moz-osx-font-smoothing: grayscale;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    transition: -webkit-transform 0.25s ease-out;
    transition: transform 0.25s ease-out;
    transition:
      transform 0.25s ease-out,
      -webkit-transform 0.25s ease-out;
  }

  .modal__btn:focus,
  .modal__btn:hover {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
  }

  .modal__btn-primary {
    background-color: #00449e;
    color: #fff;
  }

  /**************************\
  Demo Animation Style
\**************************/
  @keyframes mmfadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes mmfadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes mmslideIn {
    from {
      transform: translateY(15%);
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes mmslideOut {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(-10%);
    }
  }

  .micromodal-slide.is-open {
    display: block;
  }

  .micromodal-slide[aria-hidden='false'] .modal__overlay {
    animation: mmfadeIn 0.3s cubic-bezier(0, 0, 0.2, 1);
  }

  .micromodal-slide[aria-hidden='false'] .modal__container {
    animation: mmslideIn 0.3s cubic-bezier(0, 0, 0.2, 1);
  }

  .micromodal-slide[aria-hidden='true'] .modal__overlay {
    animation: mmfadeOut 0.3s cubic-bezier(0, 0, 0.2, 1);
  }

  .micromodal-slide[aria-hidden='true'] .modal__container {
    animation: mmslideOut 0.3s cubic-bezier(0, 0, 0.2, 1);
  }

  .micromodal-slide .modal__container,
  .micromodal-slide .modal__overlay {
    will-change: transform;
  }

  .mobile {
    .modal__container {
      padding: 20px !important;
      margin: 10px !important;
      margin-top: 70px !important;
      position: unset !important;
    }

    .modal__overlay {
      align-items: flex-start !important;
    }

    .modal-location-bottom {
      align-items: flex-end !important;
    }
  }
</style>

<span>
  {#if show}
    <div
      use:setupModal
      in:fade|global={{ duration: fadeInDuration }}
      class="b-modal micromodal-slide {$$props.class}"
      class:mobile={mobile}
      class:with-large-close-button={closeButtonSize === 'large'}
      on:keydown={handleKeydown}>
      <slot name="content-before" />
      <div
        class="modal__overlay modal-location-{modalLocation} {$$props.overlayClass}"
        on:click={() => {
          if (!clickedInside) {
            dispatch('overlay-clicked');

            if (closeOnOverlayClick) {
              hide();
            }
          }
          clickedInside = false;
        }}
        tabindex="-1">
        <div
          style={$$props.style || ''}
          class="modal__container {$$props.containerClass}"
          on:mouseup={() => {
            clickedInside = false;
          }}
          on:mousedown={() => {
            clickedInside = true;
          }}
          on:click|preventDefault|stopPropagation>
          <header class="modal__header">
            <h2 class="modal__title">
              {#if browser && SLOTS.header}
                <slot name="header" />
              {:else if header}
                {@html header}
              {/if}
            </h2>
            {#if showCloseButton}
              {#if SLOTS.close}
                <slot name="close" />
              {:else}
                <button
                  class="modal__close {BrowserUtils.isIOS() ? 'modal__close_ios' : ''} {$$props.closeButtonClass}"
                  style={$$props.closeButtonStyle}
                  on:click={hide} />
              {/if}
            {/if}
          </header>
          <main
            class="modal__content {$$props.contentClass}"
            style={$$props.contentStyle || ''}
            in:fly|global={{ x: slideInX, duration: slideInDuration, opacity: 1 }}>
            <slot name="content" />
          </main>
        </div>
      </div>
    </div>
  {/if}
</span>
